/** Display label for master-data role/department dropdown options. */
export function formatMasterOptionLabel({ code, name }) {
  const n = (name || '').trim();
  if (n) return n;
  const c = (code || '').trim();
  return c || '—';
}
